import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Decisions from "@/pages/Decisions";
import Employees from "@/pages/Employees";
import Categories from "@/pages/Categories";
import Entity from "@/pages/Entity";
import AdminPanel from "@/pages/AdminPanel";

const Protected = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="app-loading">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/decisions" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors dir="rtl" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Navigate to="/decisions" replace />} />
              <Route path="/decisions" element={<Decisions />} />
              <Route path="/employees" element={<Employees />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/entity" element={<Entity />} />
              <Route
                path="/admin"
                element={
                  <Protected adminOnly>
                    <AdminPanel />
                  </Protected>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
